var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "segmented-tabs d-flex align-center justify-space-between" },
    [
      _c("BaseToggleButton", {
        staticClass: "segmented-tabs__group",
        attrs: { segmented: "", value: _vm.value, options: _vm.options },
        on: { change: _vm.handleChange }
      }),
      _c(
        "div",
        { staticClass: "segmented-tabs__actions" },
        [_vm._t("actions")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }